import { useEffect, useState, useMemo } from "react";
import axios from "../../utils/axiosInstance";
import ButtonSimp from "../../components/button";
import Modal from "../../components/modal/Modal";

import BasicInput from "../../components/edittext/basicInput/basicInput";
import { ChevronDown, ChevronUp } from "lucide-react";

const Payment = () => {
  const [invoices, setInvoices] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [invoiceItems, setInvoiceItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [expanded, setExpanded] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // گرفتن لیست فاکتورها
  const fetchInvoices = async () => {
    try {
      setLoading(true);
      const res = await axios.get("/invoices", { withCredentials: true });
      setInvoices(res.data.data || []);
    } catch (err) {
      console.error("خطا در گرفتن فاکتورها:", err);
    } finally {
      setLoading(false);
    }
  };

  // const SearchInvoices = useMemo(() => {
  //   let result = [...invoices];
  //   if (search) {
  //     result = result.filter((c) =>
  //       c._id.slice(-6).toLowerCase().includes(search.toLowerCase())
  //     );
  //   }
  //   return result;
  // }, [invoices, search]);
  const SearchInvoices = useMemo(() => {
    let result = [...invoices];

    // فیلتر بر اساس سرچ
    if (search) {
      result = result.filter((c) =>
        c._id.slice(-6).toLowerCase().includes(search.toLowerCase())
      );
    }

    // فیلتر بر اساس بازه زمانی
    if (startDate) {
      result = result.filter(
        (c) => new Date(c.createdAt) >= new Date(startDate)
      );
    }
    if (endDate) {
      result = result.filter((c) => new Date(c.createdAt) <= new Date(endDate));
    }

    return result;
  }, [invoices, search, startDate, endDate]);

  // Pagination slice
  const totalPages = Math.ceil(SearchInvoices.length / itemsPerPage);
  const paginatedInvoices = SearchInvoices.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // گرفتن جزئیات فاکتور
  const fetchInvoiceDetails = async (invoiceId) => {
    try {
      const res = await axios.get(`/invoices/${invoiceId}`, {
        withCredentials: true,
      });
      setInvoiceItems(res.data.items || []);
    } catch (err) {
      console.error("خطا در گرفتن ریز فاکتور:", err);
    }
  };

  useEffect(() => {
    fetchInvoices();
  }, []);

  const handleShowDetails = (invoice) => {
    setSelectedInvoice(invoice);
    fetchInvoiceDetails(invoice._id);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setSelectedInvoice(null);
    setInvoiceItems([]);
    setModalOpen(false);
  };

  const toggleExpand = (id) => {
    setExpanded(expanded === id ? null : id);
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      setExpanded(null); // بستن آکاردئون در صفحه جدید
    }
  };

  return (
    <div className="container mt-4">
      <h3 className="mb-3">Payment Management</h3>

      <div className="row">
        <div className="p-0 col-12 col-lg-4">
          <BasicInput
            className="me-lg-1"
            bsize="1"
            bcolor="primary"
            margin="2"
            bgcolor="white"
            textcolor="black"
            scolor="primary"
            text="Invoice Number..."
            value={search}
            onChange={(value) => {
              setSearch(value);
              setCurrentPage(1); // ریست کردن صفحه وقتی سرچ تغییر می‌کنه
            }}
          />
        </div>
        <div className="p-1 mt-1 col-6 col-lg-4">
          <BasicInput
            className="me-lg-1"
            type="date"
            bsize="1"
            bcolor="primary"
            margin="0"
            bgcolor="white"
            textcolor="black"
            scolor="primary"
            text="StartDate"
            value={startDate}
            onChange={(value) => {
              setStartDate(value);
              setCurrentPage(1);
            }}
          />
        </div>
        <div className="p-1 mt-1 col-6 col-lg-4">
          <BasicInput
            className=" me-lg-1"
            type="date"
            bsize="1"
            bcolor="primary"
            margin="0"
            bgcolor="white"
            textcolor="black"
            scolor="primary"
            text="EndDate"
            value={endDate}
            onChange={(value) => {
              setEndDate(value);
              setCurrentPage(1);
            }}
          />
        </div>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <div>
          {/* Desktop Table */}
          <div className="d-none d-lg-block mt-3">
            <table className="table table-striped table-hover">
              <thead>
                <tr>
                  <th>Invoice Number</th>
                  <th>Total Amount</th>
                  <th>Payment Status</th>
                  <th>Date</th>
                  <th>Detail</th>
                </tr>
              </thead>
              <tbody>
                {paginatedInvoices.map((inv) => (
                  <tr key={inv._id}>
                    <td className="p-3 pt-4">{inv._id.slice(-6)}</td>
                    <td className="p-3 pt-4">{inv.totalAmount} $</td>
                    <td className="p-3 pt-4">{inv.paymentStatus}</td>
                    <td className="p-1 pt-4">
                      {new Date(inv.createdAt).toLocaleDateString("en-US")}
                    </td>
                    <td>
                      <ButtonSimp
                        size="sm"
                        padding="1"
                        text="View"
                        clicked={() => handleShowDetails(inv)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Mobile Accordion */}
          <div className="d-lg-none mt-3">
            {paginatedInvoices.map((inv) => (
              <div
                key={inv._id}
                className="border rounded mb-3 shadow-sm overflow-hidden"
              >
                <div
                  className="d-flex justify-content-between align-items-center p-2 bg-light"
                  onClick={() => toggleExpand(inv._id)}
                  role="button"
                >
                  <div>
                    <strong>Invoice #{inv._id.slice(-6)}</strong>
                    <div className="small text-muted">
                      {new Date(inv.createdAt).toLocaleDateString("en-US")}
                    </div>
                  </div>
                  {expanded === inv._id ? <ChevronUp /> : <ChevronDown />}
                </div>

                {expanded === inv._id && (
                  <div className="p-2 small bg-white">
                    <div>
                      <strong>Total:</strong> {inv.totalAmount} $
                    </div>
                    <div>
                      <strong>Status:</strong> {inv.paymentStatus}
                    </div>
                    <div className="mt-2">
                      <ButtonSimp
                        size="sm"
                        padding="1"
                        text="View Details"
                        clicked={() => handleShowDetails(inv)}
                      />
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Pagination */}
          <div className="d-flex justify-content-center mt-3">
            <nav>
              <ul className="pagination">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageChange(currentPage - 1)}
                  >
                    Previous
                  </button>
                </li>

                {Array.from({ length: totalPages }, (_, i) => (
                  <li
                    key={i}
                    className={`page-item ${
                      currentPage === i + 1 ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(i + 1)}
                    >
                      {i + 1}
                    </button>
                  </li>
                ))}

                <li
                  className={`page-item ${
                    currentPage === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageChange(currentPage + 1)}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      )}

      {/* Modal */}
      <Modal show={modalOpen} modalClosed={handleCloseModal}>
        {selectedInvoice && (
          <>
            <p>
              <strong>Invoice number:</strong> {selectedInvoice._id}
            </p>
            <p>
              <strong>Payment status:</strong> {selectedInvoice.paymentStatus}
            </p>
            <p>
              <strong>Total amount:</strong> {selectedInvoice.totalAmount} $
            </p>
            <p>
              <strong>Date:</strong>{" "}
              {new Date(selectedInvoice.createdAt).toLocaleString("en-US")}
            </p>

            <h5 className="mt-3">Invoice Details</h5>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Product</th>
                  <th>Number</th>
                  <th>Unit Price</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {invoiceItems.map((item) => (
                  <tr key={item._id}>
                    <td>{item.productId?.title}</td>
                    <td>{item.quantity}</td>
                    <td>{item.price} $</td>
                    <td>{item.price * item.quantity} $</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}
      </Modal>
    </div>
  );
};

export default Payment;
